import React, { Fragment, useEffect } from 'react'

import { parse } from 'query-string'
import { Link } from 'react-router-dom'

import { Button } from '@driftt/tide-core'

import GoogleAuth from './GoogleAuth'
import MicrosoftAuth from './MicrosoftAuth'

const SignupChoiceCard = ({
  search,
  onProcessingGoogleCode,
  onProcessingExternalGoogleCode,
  onProcessingMicrosoftCode,
  oauthError,
}) => {
  useEffect(() => window.intellimize && window.intellimize.activate(), [])
  const { plan } = parse(search)
  const nextState = '/start/signup'
  const headerCopy = plan
    ? 'Create your Drift account'
    : 'Create your free Drift account'

  return (
    <Fragment>
      <h1 className="touchless-start-header">{headerCopy}</h1>
      <Link to={nextState}>
        <Button className="touchless-start-oauth-button" size="large">
          Sign up with email
        </Button>
      </Link>
      <div className="touchless-start-oauth-border">
        <p>or</p>
      </div>
      <GoogleAuth
        onProcessingGoogleCode={onProcessingGoogleCode}
        onProcessingExternalGoogleCode={onProcessingExternalGoogleCode}
      />
      <MicrosoftAuth onProcessingMicrosoftCode={onProcessingMicrosoftCode} />
      {oauthError && (
        <p className="touchless-start-button-error">{oauthError}</p>
      )}
    </Fragment>
  )
}

export default SignupChoiceCard
